export const MAX_FAMILY_STAKE = 25000000;

export const FAMILY_CRIME_TAX_PERCENT = 5;
export const FAMILY_CAR_SELL_TAX_PERCENT = 5;
export const FAMILY_NARCS_BOOZE_TAX_PERCENT = 5;
export const FAMILY_HELPER_BOT_TAX_PERCENT = 5;

export const RANK_ACTIVATION_REDUCTION_PERCENTAGE = 40;

export const UNSTAKE_COOLDOWN_DAYS = 50;

export const UNSTAKE_COOLDOWN_MS = UNSTAKE_COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
